import Vue from 'vue'
const { i18n } = Vue

import AutoLogin from '@/views/AutoLogin'
import Login from '@/views/Login'
import RecoverPassword from '@/views/LoginRecoverPassword'
import ResetPassword from '@/views/LoginResetPassword'
import Onboarding from '@/views/Onboarding'
import OnboardingSteps from '@/views/OnboardingSteps'

export const defaultRoute = [
  {
    path: '/',
    name: 'rootLogin',
    component: Login,
    meta: {
      title: 'Login',
    },
  },

  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login',
    },
  },

  // Landing spot for the onboarding hand-off. No `meta.login` guard on purpose: the visitor has no
  // session yet — creating one from the ticket is the whole point of the route.
  {
    path: '/auto-login',
    name: 'autoLogin',
    component: AutoLogin,
    meta: {
      title: 'Login',
    },
  },

  {
    path: '/recover-password',
    name: 'recover-password',
    component: RecoverPassword,
    meta: {
      title: i18n.translate('auth.recoverPassword'),
    },
  },

  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: ResetPassword,
    meta: {
      title: i18n.translate('auth.resetPassword'),
    },
  },

  {
    path: '/onboarding',
    name: 'onboarding',
    component: Onboarding,
    meta: {
      title: 'Onboarding',
    },
  },

  {
    path: '/onboarding/steps',
    name: 'onboardingSteps',
    component: OnboardingSteps,
    meta: {
      login: true,
      title: 'Onboarding Steps',
    },
  },

  {
    path: '/confirm-appointment/:id',
    name: 'confirmAppointment',
    component: () => import('@/views/ConfirmAppointment'),
    meta: {
      title: i18n.translate('appointment.confirmAppointment.title'),
    },
  },

  {
    path: '/host-rate',
    name: 'hostRatingDone',
    component: () => import('@/views/HostRatingDone'),
    meta: {
      title: i18n.translate('hostRating.label.title'),
    },
  },

  {
    path: '/host-rate/:id',
    name: 'hostRating',
    component: () => import('@/views/HostRating'),
    meta: {
      title: i18n.translate('hostRating.label.title'),
    },
  },

  {
    path: '/quote/:id',
    name: 'quote',
    component: () => import('@/views/QuoteList'),
    meta: {
      title: i18n.translate('quote.label.title'),
    },
  },

  {
    path: '/checkout',
    name: 'checkout',
    component: () => import('@/views/Checkout'),
    meta: {
      title: i18n.translate('pages.title.checkout'),
    },
  },

  {
    path: '*',
    name: 'error404',
    component: () => import('@/views/Error404'),
    meta: {
      title: i18n.translate('pages.title.error404'),
    },
  },

  {
    path: '*',
    name: 'Erro 404',
    component: () => import('@/views/Error404'),
  },
]
